import type { DemoKey } from './keys';

export const mr: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'भूमिती · 3D',
  'panel.figure': 'आकृती',
  'panel.dims': 'मिती',
  'panel.style': 'देखावा',
  'panel.lines': 'विशेष रेषा',
  'style.body': 'पिंड',
  'style.line': 'रेषा',
  'style.cut': 'छेद',
  'style.labels': 'शिरोबिंदू नावे',
  'group.face': 'पृष्ठ कर्ण / जनक',
  'group.space': 'कर्ण / अक्ष / मध्यिका',
  'split.label': 'छेद',
  'btn.animate': 'चालवा',
  'btn.reset': 'पुन्हा सेट',
  'hint.line1': 'फिरवण्यासाठी ओढा · झूमसाठी स्क्रोल',
  'hint.line2': 'निवडण्यासाठी रेषेवर क्लिक करा',
  'fig.cuboid': 'घनाभ',
  'fig.cube': 'घन',
  'fig.triPrism': 'त्रिकोणी चश्मा',
  'fig.hexPrism': 'षटकोनी चश्मा',
  'fig.tetrahedron': 'चतुष्फलक',
  'fig.squarePyramid': 'चौकोनी पिरॅमिड',
  'fig.cylinder': 'चिती',
  'fig.cone': 'शंकू',
  'fig.sphere': 'गोल',
  'fig.frustumPyramid': 'पिरॅमिडचा छिन्नक',
  'fig.frustumCone': 'शंकूचा छिन्नक',
  'dim.length': 'लांबी',
  'dim.width': 'रुंदी',
  'dim.height': 'उंची',
  'dim.side': 'बाजू',
  'dim.radius': 'त्रिज्या',
  'dim.r1': 'खालची त्रिज्या',
  'dim.r2': 'वरची त्रिज्या',
  'dim.sideBase': 'आधार बाजू',
  'dim.sideTop': 'वरची बाजू',
  'info.face': 'पृष्ठ',
  'info.center': 'केंद्रातून',
  'info.diagonal': 'कर्ण',
  'info.axial': 'अक्षीय कर्ण',
  'info.diameter': 'व्यास',
  'info.generator': 'जनक',
  'info.axis': 'अक्ष',
  'info.height': 'उंची',
  'info.median': 'मध्यिका',
  'info.apothem': 'अपोथेम',
  'info.diameterBase': 'आधार व्यास',
  'info.diameterTop': 'वरचा व्यास',
};
